"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _link = _interopRequireDefault(require("@ux/link"));
var _arrowRight = _interopRequireDefault(require("@ux/icon/arrow-right"));
/**
 * SubstackLink Return the substack text and link as a functional Component
 *
 * @returns {Function} text and link
 * @public
 */
function SubstackLink() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "footer-substack-text"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "Sales:Footer:GoDaddy:SubstackSubscribe"
  })), /*#__PURE__*/_react.default.createElement(_link.default, {
    href: "https://godaddy.substack.com/",
    eid: "uxp.hyd.sales_footer_seechange.substack.link.click",
    className: "footer-substack-link",
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "Sales:Footer:Godaddy:SubstackLink"
  }), /*#__PURE__*/_react.default.createElement(_arrowRight.default, null)));
}
var _default = SubstackLink;
exports.default = _default;